import { Constants } from './Constants';

export class WaterEntityUtil {
	public static convertEntityType(entityType?: string) {
		switch (entityType) {
			case Constants.ENTITY_TYPE_WATER_METER:
				return 'waterMeters';
			case Constants.ENTITY_TYPE_WATER_TANK:
				return 'waterTanks';
			case Constants.ENTITY_TYPE_WATER_MONITOR:
				return 'waterMonitors';
		}
		return entityType;
	}

	public static getEntityTypeDisplayName(entityType?: string) {
		switch (entityType) {
			case Constants.ENTITY_TYPE_WATER_METER:
				return 'Supplies';
			case Constants.ENTITY_TYPE_WATER_TANK:
				return 'Storages';
			case Constants.ENTITY_TYPE_WATER_MONITOR:
				return 'Usages';
		}
		return entityType;
	}

	public static isWaterEntity(entityType?: string) {
		return entityType
			? [
					Constants.ENTITY_TYPE_WATER_TANK,
					Constants.ENTITY_TYPE_WATER_METER,
					Constants.ENTITY_TYPE_WATER_MONITOR,
			  ].includes(entityType)
			: false;
	}
}
